import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { mobileUsersRoutes } from './mobile-users.routing'
import { MobileUsersComponent } from './mobile-users.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'
import { CreateMobileUserComponent } from './create-mobile-user/create-mobile-user.component'
import { UpdateMobileUserComponent } from './update-mobile-user/update-mobile-user.component'
import { ActiveLayerMapModule } from '@components/active-layer-map/active-layer-map.module'
import { MobileUserTasksComponent } from './mobile-user-tasks/mobile-user-tasks.component'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    MobileUsersComponent,
    CreateMobileUserComponent,
    UpdateMobileUserComponent,
    MobileUserTasksComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(mobileUsersRoutes, {
      scrollPositionRestoration: 'top',
    }),
    SweetAlert2Module.forRoot(),
    HttpClientModule,
    SharedModule,
    ActiveLayerMapModule,
    BreadcrumbsModule,
  ],
  exports: [MobileUsersComponent],
})
export class MobileUsersModule {}
